
  import ModelItems from '@/mixins/ModelItems';
  import {ActivitySkillsLevel} from '@/model/Profile';
  import Activities from '@/model/Activity';

  export default {
    name: 'ActivitySkillsSubForm',
    mixins: [ModelItems],
    props: {
      activitySkill: {
        type: Object,
        required: true,
      },
      i: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        internalActivitySkill: {},
        activitySkillItems: this.prepareModelItems(Activities),
        levelItems: this.prepareModelItems(ActivitySkillsLevel),
      };
    },
    watch: {
      activitySkill: {
        deep: true,
        handler() {
          this.internalActivitySkill = this.activitySkill;
        },
      },
    },
    created() {
      this.internalActivitySkill = this.activitySkill;
    },
    methods: {
      updateGroupValidity(validate) {
        this.$emit('validate', validate);
      },
    },
  };
